/**
 * Converts an input string to kebab-case
 * @module kebabCase
 * @param {string} string - The string to be converted
 * @return {string} - The string now in kebab case
 */
export default function toKebabCase(string) {
    return string
        .replace(/([a-z])([A-Z])/g, '$1-$2')
        .replace(/([-!$%^&*()_+|~=`{}[\]:";'<>?,./])/g, '-')
        .toLowerCase()
        .replace(/\s+/g, '-')
        .toLowerCase();
}
